import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram } from '../Icons/CustomIcons';

function FooterSocial() {
  return (
    <div className="footer-social">
      <a
        href="https://www.facebook.com"
        target="_blank"
        rel="noopener noreferrer"
        className="footer-social-link footer-social-link--facebook"
        aria-label="Facebook"
      >
        <Facebook size={20} />
      </a>
      <a
        href="https://www.instagram.com"
        target="_blank"
        rel="noopener noreferrer"
        className="footer-social-link footer-social-link--instagram"
        aria-label="Instagram"
      >
        <Instagram size={20} />
      </a>
    </div>
  );
}

function FooterNav() {
  return (
    <nav className="body Font-S-I-120-D Colors-Black footer-nav">
      <div className="footer-nav__block">
        <Link to="/ueber-uns" className="footer-link">Über uns</Link>
        <Link to="/impressum" className="footer-link">Impressum</Link>
      </div>
      <div className="footer-nav__block">
        <Link to="/datenschutz" className="footer-link">Datenschutz</Link>
        <Link to="/aufnahmeregeln" className="footer-link">Aufnahmeregeln</Link>
      </div>
    </nav>
  );
}

function FooterLogo() {
  return (
    <Link to="/" className="footer-logo" aria-label="Zur Startseite">
      <img src="/favicon.svg" className="footer-logo-img" alt="Grosskinder Aktiv" />
    </Link>
  );
}

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Top row: Logo | Nav | Social */}
        <div className="footer-top">
          <div className="footer-top-row">
            <FooterLogo />
            <FooterSocial />
          </div>

          <FooterNav />

        </div>

        {/* Copyright */}
        <div className="body Font-S-B-120-D Colors-Grey-05 footer-copyright">
          <p>&copy; 2026 Grosskinder Aktiv. Eine Initiative der Klimagrosseltern Winterthur. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
